module.exports = __webpack_public_path__ + "img/rp_08.db09b820.jpg";